module.exports = __webpack_public_path__ + "img/001-working.c8299c5f.svg";